<template>
  <div>
    <div class="page-vip" @scroll.stop="handleScroll">
      <div v-show="isHeaderFixed" class="header-fixed" @click="back">
        <div class="back"></div>
        <p>开通会员</p>
      </div>
      <div class="header"></div>
      <div class="content">
        <h1>购买VIP会员</h1>
        <p class="details">
          黄金VIP会员只限于看视频；钻石VIP会员全平台无限制。
        </p>
        <ul class="recharge-container">
          <li
            v-for="(item, index) in vips"
            :key="index"
            :class="{ active: active === item.name }"
            @click="handleClick(item.name)"
          >
            <h2>{{ item.name }}</h2>
            <p class="price"><span>¥</span>{{ item.amount }}</p>
            <p class="time">{{ item.dec }}</p>
          </li>
        </ul>
        <button class="buy" @click="navigateTo">购买</button>
      </div>
      <Popularize />
      <Privilege />
    </div>
    <NavigationBottom />
  </div>
</template>

<script>
import NavigationBottom from "@/components/NavigationBottom/index";
import Popularize from "@/views/vip/components/Popularize";
import Privilege from "@/views/vip/components/Privilege";

import { getVipCombos } from "@/api/vip";
import { WATCH_VIDEO_IDENTITY } from "@/utils/watchVideoNum";
import { mapState } from "vuex";

export default {
  name: "Vip",
  components: {
    Privilege,
    Popularize,
    NavigationBottom
  },
  data() {
    return {
      active: 0,
      isHeaderFixed: false,
      vips: []
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapState("platform", ["vipId"]),
    getVipDays() {
      return localStorage.getItem(WATCH_VIDEO_IDENTITY);
    }
  },
  methods: {
    async fetchData() {
      this.vips = await getVipCombos();
    },
    handleClick(index) {
      this.active = index;
    },
    handleScroll(event) {
      this.isHeaderFixed = event.target.scrollTop > 36;
    },
    back() {
      this.$router.back();
    },
    navigateTo() {
      console.log(this.vipId);
      this.$router.push({ name: "chat", params: { id: this.vipId } });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-vip {
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  overflow: scroll;
  padding: 0 0 90px 0;
  .header {
    height: 76px;
    width: 100%;
    background-image: url("../../assets/vip/head_bg.png");
    background-size: 100% 100%;
  }
  .header-fixed {
    position: fixed;
    height: 40px;
    width: 100%;
    background: rgba(61, 62, 73, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    .back {
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      background-image: url("../../assets/vip/back@2x.png");
      background-size: 9px 14px;
      background-position: center;
      background-repeat: no-repeat;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: rgba(228, 191, 88, 1);
    }
  }
  .content {
    padding: 0 15px 30px 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    h1 {
      margin: 15px 0 5px 0;
      font-size: 18px;
      font-weight: 500;
      color: rgba(50, 51, 51, 1);
      line-height: 25px;
    }
    .details {
      font-size: 12px;
      font-weight: 400;
      color: rgba(228, 191, 88, 1);
      line-height: 17px;
    }
    .recharge-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      width: 100%;
      margin: 15px 0 25px 0;
      text-align: center;
      li {
        display: flex;
        flex-direction: column;
        padding: 7px 0 13px 0;
        width: 100%;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(230, 230, 235, 1);
        h2 {
          font-size: 14px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }
        .price {
          margin: 17px 0 14px 0;
          font-size: 28px;
          font-weight: 600;
          color: rgba(228, 191, 88, 1);
          line-height: 22px;
          span {
            font-size: 15px;
            font-weight: 600;
          }
        }
        .time {
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
        }
      }
      .active {
        border: 1px solid rgba(228, 191, 88, 1);
        background: rgba(255, 248, 229, 1);
      }
    }
    .buy {
      width: 100%;
      height: 42px;
      background: linear-gradient(
        270deg,
        rgba(242, 201, 91, 1) 0%,
        rgba(254, 222, 136, 1) 100%
      );
      border: none;
      border-radius: 28px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(111, 69, 8, 1);
      line-height: 21px;
    }
  }
}
</style>
